export const getHeadingColourFromTextColour = (
  textColour?: '#FFFFFF' | '#1E1E34'
) => (textColour === '#FFFFFF' ? 'white' : 'textPrimary');
